export const CHAR = {
	NBSP: '\u00A0',
} as const;
